import { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Container, Stack, Typography } from '@mui/material';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Unhandled render error:', error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (!hasError) {
      return children;
    }

    return (
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center', py: 10 }}>
          <Typography variant="h4" gutterBottom>
            Something went wrong
          </Typography>

          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 3 }}>
            The page failed to load. Reloading usually fixes it. If it keeps happening, please report it.
          </Typography>

          {process.env.NODE_ENV !== 'production' && error && (
            <Typography
              variant="caption"
              component="pre"
              sx={{
                textAlign: 'left',
                p: 2,
                mb: 3,
                bgcolor: 'background.neutral',
                borderRadius: 1,
                overflow: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {error.toString()}
            </Typography>
          )}

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button variant="contained" onClick={this.handleReload}>
              Reload page
            </Button>
            <Button variant="outlined" onClick={this.handleGoHome}>
              Go to home
            </Button>
          </Stack>
        </Box>
      </Container>
    );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;
